import cls from "pages/MainPage/ui/MainPage.module.scss";
import { classNames } from "shared/lib/classNames/classNames";
import Title from "shared/ui/Title/Title";
import Paragraph, { ParagraphTheme } from "shared/ui/Paragraph/Paragraph";
import DotGridBackground from "../../shared/ui/DotGridBackground";

const AboutPage = () => {
    return (
        <div id={"mainPage"} className={cls.indexPage}>
            <DotGridBackground />
            <section className={classNames("page-section", {}, [cls.indexPage__about])}>
                <div className={classNames("container container__main")}>
                    <div className={cls.About}>
                        <div style={{padding: '0 200px'}}>
                            <Title className={cls.indexPage__title} sentences={["About Us"]}/>

                            <Paragraph theme={ParagraphTheme.BRIGHT} style={{marginBottom: 32, marginTop: 32, color: '#262F35'}}>
                                About SBS CONSULTING STRATEGIES LTD
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} style={{marginBottom: 32, color: '#262F35'}}>
                                SBS CONSULTING STRATEGIES LTD is a dynamic company dedicated to creating high-quality apps and digital experiences for a diverse audience. Our latest project, Bloxsy: Steal Games, is crafted to bring creativity, excitement, and endless customization to fans of block-style games around the world.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} style={{marginBottom: 32, color: '#262F35'}}>
                                At SBS CONSULTING STRATEGIES LTD, we are passionate about building intuitive, user-friendly applications that enhance your gameplay. Our mission is to develop innovative and engaging tools that unlock new possibilities—whether you're a casual gamer or a dedicated enthusiast.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} style={{marginBottom: 32, color: '#262F35'}}>
                                Our talented team of developers, designers, and support professionals work diligently to ensure that our apps are simple to use, frequently updated, and continually refined to meet your needs. We place a strong emphasis on user feedback and aim to create experiences that go beyond expectations.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} style={{marginBottom: 32, color: '#262F35'}}>
                                We are equally committed to your safety and privacy, building a secure environment where you can confidently enjoy our services. Whether you're seeking unique skins, thrilling mods, or powerful tools, SBS CONSULTING STRATEGIES LTD is here to offer the very best in gaming enhancements.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} style={{marginBottom: 32, color: '#262F35'}}>
                                If you have any questions or suggestions, we encourage you to reach out to us at any time. We’re always eager to hear from our users and to evolve our platform based on your insights.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} style={{marginBottom: 32, color: '#262F35'}}>
                                Thank you for choosing SBS CONSULTING STRATEGIES LTD as your gaming companion!
                            </Paragraph>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutPage;
